import { analyticsEvents, ButtonClickedProperties, PageViewedProperties } from "@/services/analytics/analytics-events"
// @ts-ignore
import store from "@/store"
import { BaseUser } from "@vitable/asclepius-api-client-ts"

function _getDefaultEventProperties() {
  return {
    user_id: store.getters["me/userId"],
    user_type: store.getters["me/user"]?.user_type,
    name: store.getters["me/user"]?.full_name
  }
}

function _isInited() {
  // @ts-ignore
  return freshpaint.track
}

function track(event: string, properties?: any) {
  if (!_isInited()) return

  // @ts-ignore
  freshpaint.track(event, properties)
}

function pageViewed(properties: PageViewedProperties) {
  if (!_isInited()) return

  // @ts-ignore
  freshpaint.track(analyticsEvents.PAGE_VIEWED, properties)
}

function buttonClicked(properties: ButtonClickedProperties) {
  if (!_isInited()) return

  // @ts-ignore
  freshpaint.track(analyticsEvents.BUTTON_CLICKED, properties)
}

function loggedIn(user: BaseUser) {
  if (!store.getters["me/userId"]) throw new Error("Must be logged in to call this method!")
  if (!_isInited()) return

  // @ts-ignore
  freshpaint.addEventProperties(_getDefaultEventProperties())
  // @ts-ignore
  freshpaint.identify(user.id, {
    /* user properties */
    name: user.clinical_admin?.full_name ?? user.provider?.full_name,
    user_id: user.id,
    user_type: user.user_type,
    provider_id: user.provider?.id ?? undefined
  })
  // @ts-ignore
  freshpaint.track(analyticsEvents.LOG_IN)
}

function loggedOut() {
  if (!store.getters["me/userId"]) return
  if (!_isInited()) return

  for (const key of Object.keys(_getDefaultEventProperties())) {
    // @ts-ignore
    freshpaint.removeEventProperty(key)
  }
}

export default {
  track,
  pageViewed,
  buttonClicked,
  loggedIn,
  loggedOut
}
